module.exports = __webpack_public_path__ + "img/Sichuan-power.addf58da.png";